import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./AboutUs.css";
import HeroSection from "../../components/heroSection/HeroSection";
import Footer from "../../components/footer/Footer";
import CTASection from "../../components/ctaSection/CTASection";

const phone2 = "/images/phone2.png";
const Traditional_Wedding = "/images/helpfully_image.png";

const AboutUs = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [menuOpen, setMenuOpen] = useState(false);

  const handleNewsletterSubmit = (e) => {
    e.preventDefault();
    alert("Thank you for subscribing!");
    setEmail("");
  };

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  const handleNavClick = (page) => {
    navigate(page);
  };

  const handleLogin = () => {
    console.log("Login clicked");
    navigate("/onboarding");
  };

  const handleGetStarted = () => {
    console.log("Get Started clicked");
    navigate("/onboarding");
  };

  return (
    <div className="about-us-page">
      <HeroSection
        title="About Us"
        description="NimbleBash is driven by a passion to bring the vibrant spirit of Nigerian events to life. Our platform empowers users to plan, organize, and manage events seamlessly, allowing them to invite guests, track their events, manage event attire, and collect cash gifts from guests all in one app. The NimbleBash mission is to turn your dream events into reality, making it easy to create unforgettable experience."
        showDecorative={true}
        variant="about"
        activeNav="about"
        onNavClick={handleNavClick}
        onLoginClick={handleLogin}
        onGetStartedClick={handleGetStarted}
      />

      <div className="about-us-who-we-are-container">
        <section className="about-us-who-we-are">
          <img
            src={Traditional_Wedding}
            alt="Traditional Nigerian Wedding"
            className="about-us-who-we-are-image"
          />
          <div className="about-us-who-we-are-content">
            <h3>Who We Are</h3>
            <h2>
              We're <span className="about-us-highlight">Helpful</span>
            </h2>
            <p>
              NimbleBash is a product of Nimble-Byte, a forward-thinking
              technology company dedicated to building smart, scalable, and
              user-focused software solutions for businesses across various
              industries. Our mission is to simplify complex problems through
              innovation, intuitive design, and reliable digital tools that help
              companies operate more efficiently.
            </p>
            <p>
              NimbleBash is one of our flagship products created to transform
              how hosts plan, organize, and manage their events. Designed for
              simplicity and efficiency, the app brings together everything you
              need in one platform: smart digital invitations, real-time invite
              tracking, secure in-app payments, guest check-in tools, and a
              seamless dashboard that keeps you in control from start to finish.
            </p>
          </div>
        </section>
      </div>

      {/* CTA Section */}
      <CTASection
        title="Join Others to"
        highlight1="Xperience Luxury Event"
        highlight2="Management"
        description="Join thousands of users in elevating your event experience! Plan, manage, and attend events with ease, while sending cash gifts to your loved ones. Download our app on Google Play or Apple Store, or sign up on our website to enjoy our web version."
        image={phone2}
        onGooglePlayClick={() =>
          window.open(
            "https://play.google.com/store/apps/details?id=com.nimblebash.nimblebyte"
          )
        }
        onAppleStoreClick={() =>
          window.open("https://apps.apple.com/ng/app/nimblebash/id6752389351")
        }
        onWebSignupClick={() => navigate("/onboarding")}
      />

      <Footer />
    </div>
  );
};

export default AboutUs;
